<template>
  <div
    :class="horizontal ? 'flex justify-between space-x-4' : 'block'"
    v-for="row in rows"
    :key="row"
  >
    <Skeleton
      :class="horizontal ? 'w-full' : 'mb-4'"
      v-for="row in length"
      :key="row"
      :height="itemHeight"
    ></Skeleton>
  </div>
</template>

<script setup>
defineProps({
  length: Number,
  itemHeight: {
    type: String,
    default: '1rem',
  },
  horizontal: {
    type: Boolean,
    default: false,
  },
  square: {
    type: Boolean,
    default: false,
  },
  rows: {
    type: Number,
    default: 1,
  },
});
</script>
